import { AppText, FlexColumn, FlexRow } from "src/style";
import GBP from "../../assets/svg/gbp-icon"; // Replace with appropriate icons
import USD from "../../assets/svg/usd-icon";
import EUR from "../../assets/svg/eur-icon";
import { useState } from "react";

const currencies = [
  { code: "GBP", amount: "£1000.00", bgColor: "#F5F8FF", icon: <GBP /> },
  { code: "USD", amount: "£0.00", bgColor: "#FFF8F5", icon: <USD /> },
  { code: "EUR", amount: "£0.00", bgColor: "#F5FFF8", icon: <EUR /> },
];

export const CbpCurrencyList = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <FlexColumn
      width="50"
      height="25"
      radius="2"
      padding="2"
      bgColor="#FFFFFF"
      // borderWidth="1"
      // borderColor="#EAECF0"
    >
      <FlexRow gap="1" style={{ flexWrap: "wrap" }}>
        {currencies.map((currency, index) => (
          <CbpCurrencyCard
            key={index}
            code={currency.code}
            amount={currency.amount}
            bgColor={currency.bgColor}
            icon={currency.icon}
          />
        ))}
      </FlexRow>

      {/* Pagination Dots */}
      <FlexRow
        style={{
          position: "absolute",
          bottom: "-15px",
          left: "90%",
        }}
      >
        {currencies.map((_, index) => (
          <div
            key={index}
            style={{
              width: "6px",
              height: "6px",
              margin: "0 3px",
              borderRadius: "50%",
              backgroundColor: index === activeIndex ? "#0D968F" : "#D3D3D3",
              cursor: "pointer",
            }}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </FlexRow>
    </FlexColumn>
  );
};

const CbpCurrencyCard = ({
  code,
  amount,
  bgColor,
  icon,
}: {
  code: string;
  amount: string;
  bgColor: string;
  icon: JSX.Element;
}) => {
  return (
    <FlexColumn
      width="14"
      height="10"
      radius="1"
      borderColor="#EAECF0"
      borderWidth="1"
      alignItems="flex-start"
      padding="2"
      bgColor={bgColor}
    >
      <FlexRow>
        {icon}
        <AppText leftMargin="1" fontWeight="400" textSize="1.4">
          {code}
        </AppText>
      </FlexRow>
      <AppText fontWeight="700" textSize="1.4" topMargin="0.5">
        {amount}
      </AppText>
    </FlexColumn>
  );
};
